import { Link, type LinkProps } from 'react-router-dom';
import { useModulePath } from '../context/ModulePathContext';

/**
 * Drop-in replacement for react-router-dom's Link. This app's routes are
 * written as absolute paths (e.g. to='/submit-change') that are correct
 * standalone, but when federated into a host shell the app is mounted at a
 * prefix (e.g. '/change-management') that plain absolute links don't know
 * about. This prepends that prefix; it's a no-op when running standalone.
 */
export function ModuleLink({ to, ...props }: LinkProps) {
  const basePath = useModulePath();
  const resolvedTo =
    basePath && typeof to === 'string' && to.startsWith('/')
      ? `${basePath}${to === '/' ? '' : to}`
      : to;

  return <Link to={resolvedTo} {...props} />;
}
